/** @jsx jsx */
import { css, jsx } from "@emotion/core"
import React, { useEffect } from "react"
import { Fields } from "@cd2/forms"
import { IRowProps } from "./quoteOrderUtils"
import { isTempId } from "../../utils/utils"
import { RemoveRowButton } from "../../Components/Buttons/RemoveRowButton"
import { useBetaFeatureAccess } from "../../Components/BetaFeatureAccess"
import { Spacer } from "@cd2/components"

export function CustomTextInput({
  registerItem,
  data,
  onChange,
  errors,
  onRemove,
  type,
}: IRowProps<{ body: string }>) {
  const hasBetaFeatureAccess = useBetaFeatureAccess()
  useEffect(
    () =>
      registerItem({
        validate(item) {
          if (item.body.trim().length === 0) {
            return { warnings: ["A custom text row has an empty body and will be removed"] }
          }
        },
        onSave(item) {
          if (item.body.trim().length === 0) {
            return { id: item.id, $deleted: true }
          } else {
            return item
          }
        },
      }),
    [],
  )

  return (
    <React.Fragment>
      <div>
        <Fields.TextArea
          value={data.body}
          onChange={val => onChange({ body: val })}
          placeholder="Enter any text..."
          error={errors.body}
          onBlur={() => onChange({ body: (data.body ?? "").toUpperCase() })}
          inputProps={{
            autoFocus: isTempId(data.id),
            style: { height: 40 },
          }}
        />
        {type == "order" && (
          <React.Fragment>
            <Spacer />
            <Fields.Checkbox
              label="Show on customer documents"
              onChange={() =>
                onChange({ sage_show_on_customer_documents: !data.sage_show_on_customer_documents })
              }
              value={!!data.sage_show_on_customer_documents}
            />
          </React.Fragment>
        )}
        {hasBetaFeatureAccess("richQuoteEmail") && type == "quote" && (
          <div
            css={css`
              padding: 8px 0 0 0;
            `}
          >
            <Fields.Checkbox
              label="Optional"
              onChange={() => onChange({ is_rich_quote_optional: !data.is_rich_quote_optional })}
              value={!!data.is_rich_quote_optional}
            />
          </div>
        )}
      </div>
      <RemoveRowButton onRemove={onRemove} />
    </React.Fragment>
  )
}
